import axios from 'axios'

export default {
  /**
   * 添加商品到购物车
   */
  addToCart(params) {
    return axios({
      url: '/product-service/api/cart/add',
      method: 'post',
      data: params
    })
  },

  /**
   * 获取购物车列表
   */
  getCartList(userId) {
    return axios({
      url: '/product-service/api/cart/list',
      method: 'get',
      params: { userId }
    })
  },

  /**
   * 更新购物车商品数量
   */
  updateQuantity(params) {
    return axios({
      url: '/product-service/api/cart/update/quantity',
      method: 'post',
      data: params
    })
  },

  /**
   * 从购物车删除商品
   */
  deleteCartItem(params) {
    return axios({
      url: '/product-service/api/cart/delete',
      method: 'post',
      data: params
    })
  },

  /**
   * 清空购物车
   */
  clearCart(userId) {
    return axios({
      url: '/product-service/api/cart/clear',
      method: 'post',
      params: { userId }
    })
  }
}